import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AdvertList from '../components/AdvertList/AdvertList';
import ShowMore from '../components/UI/ShowMore/ShowMore';
import MetaTags from '../components/MetaTags/MetaTags';
import productActions from '../store/actions/productActions';
import categoriesActions from '../store/actions/categoriesActions';
import helpers from '../helpers/helpers';
import Banner from '../components/Banner/Banner';
import Container from '../components/UI/Container/Container';
// import CollectionsTable from '../components/CollectionsTable/CollectionsTable';
import AdvertsFilter from '../components/AdvertsFilter/AdvertsFilter';

const Main = () => {
  const {
    products,
    pagination,
    categories,
    isPageLoading,
    language,
  } = useSelector((state) => ({
    products: state.products,
    pagination: state.products.pagination,
    categories: state.categories.categoriesList,
    isPageLoading: state.isPageLoading,
    language: state.language,
  }));

  const dispatch = useDispatch();

  const { getTranslationText } = helpers;

  useEffect(() => {
    const params = {
      include: 'auction_bids',
    };
    dispatch(productActions.getAllProducts(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  useEffect(() => {
    if (!categories.data.length) {
      dispatch(categoriesActions.getCategories());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefresh = () => {
    if (!products.isLoading) {
      const params = {
        include: 'auction_bids',
      };
      dispatch(productActions.getAllProducts(params));
    }
  };

  const showMore = () => {
    if (!products.isLoading) {
      const params = {
        page: pagination.current_page + 1,
        include: 'auction_bids',
      };
      dispatch(productActions.getAllProducts(params, true));
    }
  };

  return (
    <>
      <MetaTags
        metaTitle="NFT marketplace BIT.TEAM"
        metaDescription={helpers.getTranslationText('seo.main_description')}
      />
      <Container>
        <Banner/>
        {/*<CollectionsTable/>*/}
        <AdvertsFilter
          onRefresh={handleRefresh}
        />
        <AdvertList
          products={products.allProducts}
          isLoading={products.isLoading || isPageLoading}
        />
        {
          pagination.currentPage !== pagination.total_pages && !!products?.allProducts?.length && (
            <ShowMore
              href=""
              text={getTranslationText('main.show_more')}
              onClick={showMore}
            />
          )
        }
      </Container>
    </>
  );
};

export default Main;
